<script setup>
import { computed, defineProps } from 'vue';

const props = defineProps({
  side: {
    required: true,
    type: String,
  },
});
const cssClasses = computed(() => {
  return {
    'c-content-panel--left': props.side === 'left',
    'c-content-panel--right': props.side === 'right',
    'c-content-panel--modal': props.side === 'modal',
  };
});
</script>

<template>
  <div :class="cssClasses" class="c-content-panel">
    <slot />
  </div>
</template>

<style lang="scss">
@import 'sass-mq';
@import '@/ui/styles/functions/functions';
@import '@/ui/styles/settings/breakpoints';
@import '@/ui/styles/settings/colors';
@import '@/ui/styles/settings/units';

.c-content-panel {
  width: 100%;

  &--left {
    @include mq($from: large) {
      left: 0;
    }
  }

  &--right {
    @include mq($from: large) {
      right: 0;
    }
  }

  @include mq($from: large) {
    position: absolute;
    top: 0;
    z-index: 1;
    height: 100%;
    max-width: rem(341px);
    background-color: $white;
    transform: translateX(0);
  }
}

.c-content-panel--modal {
  @include mq($from: large) {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 2;
    height: auto;
    width: calc(100% - #{$spacing-large});
    max-width: rem(1060px);
    max-height: rem(780px);
    overflow-y: auto;
    background-color: $white;
    transform: translate(-50%, -50%);
  }
}
</style>
